import { render } from "./CreateExtension.vue?vue&type=template&id=783930eb&scoped=true"
import script from "./CreateExtension.vue?vue&type=script&lang=js"
export * from "./CreateExtension.vue?vue&type=script&lang=js"

import "./CreateExtension.vue?vue&type=style&index=0&id=783930eb&scoped=true&lang=less"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-783930eb"]])

export default __exports__